function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "P7hA",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8fe4f8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#69e0db"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.521 2.912)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 48,
  transform: "translate(1.521 -2.912)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-16257.64-16051.174s-20.677-13.227-20.677-22.61,10.673-19.025,20.677-9.021c9.646-9.645,20.426-.979,20.426,9.021S-16257.64-16051.174-16257.64-16051.174Z",
  transform: "translate(16282.317 16090.23)",
  fill: "url(#P7hA)"
}));

function SvgHeartActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartActive);
export default __webpack_public_path__ + "static/media/heart-active.da0210fa.svg";
export { ForwardRef as ReactComponent };